import React, { Component, useReducer } from 'react';
import {Collapse,Navbar,NavbarToggler,NavbarBrand,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import { AiOutlineUser } from "react-icons/ai";
import {Backend_Url} from './backend_url'
import Logo from '../images/logos/white_transparent.png'
import { IoMdNotificationsOutline } from 'react-icons/io';
import Notification from '../sounds/notification.wav'

  class NavBar extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        isOpen: false,
        dropdownOpen: false,
        dropdownOpen1: false,
        dropdownOpen3: false,
        user_details: {},
        notifications: []
      };

      this.OnClickNotification = (notification) => {
        const {cookies} = this.props

        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('notification_id', notification._id.$oid)

        axios.post(Backend_Url + 'notificationRead', data)
        .then((res) => {
            let result = res.data
        }).catch((error) => {
            console.log(error)
        })

        var category = notification.category
        if(category == 'live_session'){
          let port = (window.location.port ? ':' + window.location.port : '');
          window.location.href = '//' + window.location.hostname + port + '/live-session/' + notification.event_id
        }else{
          let port = (window.location.port ? ':' + window.location.port : '');
          window.location.href = '//' + window.location.hostname + port + '/dashboard/' + notification.category
        }
      }

      this.SelectNavbarRender = () => {
        const {cookies} = this.props
        var token = cookies.get('token')
          return<Navbar  color="light" light expand="md" sticky='top' style={{marginBottom: '0px'}}>
            {
              token != null
              ? <>
                <NavbarBrand href="/home" style={{height: '100%', marginLeft: '10px', marginTop: '0px', textAlign: 'left'}}>
                  {/* <img src={Logo} style={{width: '10%'}} />  */}
                  <span style={{color: '#47525E', fontWeight: 'bold', fontFamily: 'Knewave', textAlign: 'left', fontSize: '30px'}}>ONFIT</span>
                </NavbarBrand>
              </>
              : <>
                <NavbarBrand href="/" style={{height: '100%', marginLeft: '10px', marginTop: '0px', textAlign: 'left'}}>
                  {/* <img src={Logo} style={{width: '10%'}} />  */}
                  <span style={{color: '#47525E', fontWeight: 'bold', fontFamily: 'Knewave', textAlign: 'left', fontSize: '30px'}}>ONFIT</span>
                </NavbarBrand>
              </>
            }
            <NavbarToggler onClick={this.toggle} style={{border: '1px solid'}}/>
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                {
                  token != null 
                  ? <>
                    <NavItem>
                      <NavLink></NavLink>
                    </NavItem>                
                    <NavItem>
                      <NavLink>
                      <Button id='home' href="/home" style={{backgroundColor: 'inherit', border: 'none', color: '#3C1874', fontWeight: 'bold'}}>
                            HOME
                      </Button>
                      </NavLink>
                    </NavItem>
                  </>
                  : <>

                  </>
                }
                <NavItem>
                    <NavLink></NavLink>
                </NavItem>
                <NavItem>
                    <NavLink>
                    <Button id='trainers' href="/trainers" style={{backgroundColor: 'inherit', border: 'none', color: '#3C1874', fontWeight: 'bold'}}>
                        TRAINERS
                    </Button>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink></NavLink>
                </NavItem>
                <NavItem>
                    <NavLink>
                    <Button id='explore' href="/explore" style={{backgroundColor: 'inherit', border: 'none', color: '#3C1874', fontWeight: 'bold'}}>
                        EXPLORE
                    </Button>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink></NavLink>
                </NavItem>
                <NavItem>
                    <NavLink>
                    <Button id='pricing' href="/pricing" style={{backgroundColor: 'inherit', border: 'none', color: '#3C1874', fontWeight: 'bold'}}>
                        PRICING
                    </Button>
                    </NavLink>
                </NavItem>
                <this.ValidateSignin/>
              </Nav>
            </Collapse>
          </Navbar>
      }

      this.toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
      };

      this.dtoggle = () => {
        this.setState(prevState => ({
          dropdownOpen2: !prevState.dropdownOpen
        }));
      }

      this.onMouseEnter = () => {
        this.setState({dropdownOpen: true});
      };
    
      this.onMouseLeave = () => {
        this.setState({dropdownOpen: false});
      };

      this.dtoggle1 = () => {
        this.setState(prevState => ({
          dropdownOpen1: !prevState.dropdownOpen1
        }));
      }

      this.onMouseEnter1 = () => {
        this.setState({dropdownOpen1: true});
      };
    
      this.onMouseLeave1 = () => {
        this.setState({dropdownOpen1: false});
      };

      this.dtoggle3 = () => {
        this.setState(prevState => ({
          dropdownOpen3: !prevState.dropdownOpen3
        }));
      }

      this.onMouseEnter3 = () => {
        this.setState({dropdownOpen3: true});
      };
    
      this.onMouseLeave3 = () => {
        this.setState({dropdownOpen3: false});
      };
     
      this.Signout = () =>{
        const { cookies } = this.props;

        axios.get(Backend_Url + 'deactivateAccessToken/' + cookies.get('token'))
        .then(res => {
          cookies.remove('token', { path: '/' });
          let port = (window.location.port ? ':' + window.location.port : '');
          window.location.href = '//' + window.location.hostname + port + '/signin';
        })
        .catch((error) => {
          alert('A network error occured while trying to sign you out, please try again.')
        });
      };

      this.ValidateSignin = () => {
        const { cookies } = this.props;
        if(cookies.get('token')==null){
            return<Nav className="ml-auto" navbar>
                <NavItem>
                    <NavLink></NavLink>
                </NavItem>
                <NavItem>
                    <NavLink>
                    <Button href="/signin" style={{backgroundColor: 'inherit', borderRadius: '20px', border: '2px solid #3C1874', color: '#3C1874', fontWeight: 'bold'}}>
                          Signin
                    </Button>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink></NavLink>
                </NavItem>
            </Nav>
          }else{
            var user_details = this.state.user_details;
            var notifications = this.state.notifications
            return<Nav className="ml-auto" navbar>
                <NavItem>
                    <NavLink></NavLink>
                </NavItem>
                <NavItem>
                    <NavLink>
                    <Button href="/dashboard" style={{backgroundColor: 'inherit', borderRadius: '20px', border: '2px solid #20B8FF', color: '#20B8FF', fontWeight: 'bold'}}>
                          Dashboard
                    </Button>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink></NavLink>
                </NavItem>
                <NavItem>
                    <NavLink>
                      <Dropdown className="d-inline-block" onMouseOver={this.onMouseEnter3} onMouseLeave={this.onMouseLeave3} isOpen={this.state.dropdownOpen3} toggle={this.dtoggle3}>
                        <DropdownToggle  style={{marginTop: '', backgroundColor:  'inherit', border: 'none', fontSize: '10px', color: '#1faced'}}>
                          <IoMdNotificationsOutline style={{color: '#1faced'}} size='25px'/> {notifications.length}
                        </DropdownToggle>
                        <DropdownMenu style={{marginLeft: '-250px'}}>
                          {notifications.map((notification, index) => {
                            return<DropdownItem style={{fontSize: '13px'}}>
                                <NavLink onClick={() => this.OnClickNotification(notification)} style={{color: 'black', backgoundColor: 'inherit'}} >
                                  {notification.title}
                                </NavLink>
                            </DropdownItem>
                          })}
                        </DropdownMenu>
                      </Dropdown>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink></NavLink>
                </NavItem>
                <NavItem>
                  <Dropdown className="d-inline-block" onMouseOver={this.onMouseEnter} onMouseLeave={this.onMouseLeave} isOpen={this.state.dropdownOpen} toggle={this.dtoggle}>
                    <DropdownToggle  style={{marginTop: '', backgroundColor:  'inherit', border: 'none', fontSize: '10px', color: '#3C1874'}}>
                        <Row style={{width: '80px'}}>
                          <Col style={{textAlign: 'center'}}>
                            {user_details.firstname} {user_details.lastname}
                          </Col>
                        </Row>
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem  onClick={this.Signout}>
                            <NavLink style={{color: 'black', backgoundColor: 'inherit'}} >
                                Signout
                            </NavLink>
                        </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </NavItem>
            </Nav>
          }
      };
      
      this.UpdateNotifications = () => {
        const {cookies} = this.props
        
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))

        axios.post(Backend_Url + 'notifications', data)
        .then((res) => {
            let result = res.data
          var is_array = Array.isArray(result)
          if(is_array){
            if(result.length != 0){
                this.setState({notifications: result})
                
                // notification array cookie
                var array_string = cookies.get('notifications');

                if(array_string == null){
                    var notification_array = []

                    for (var i = 0; i < result.length; i++){
                        var notification_id = result[i]._id.$oid

                        // play sound alert
                        const alert_sound = new Audio(Notification);
                        alert_sound.play()

                        // add notification to notification array cookie
                        notification_array.push(notification_id)
                    }
                    var notifications_json_string = JSON.stringify(notification_array);
                    cookies.set('notifications', notifications_json_string, { path: '/' })

                }else{
                    var notification_array = JSON.parse(array_string);

                    for (i = 0; i < result.length; i++){
                        var notification_id = result[i]._id.$oid

                        // check if notification sound alert has already been put out
                        var alert_sent = notification_array.includes(notification_id)

                        if(alert_sent == false){
                            // play sound alert
                            const alert_sound = new Audio(Notification);
                            alert_sound.play()

                            // add notification to notification array cookie
                            notification_array.push(notification_id)
                            var notifications_json_string = JSON.stringify(notification_array);
                            cookies.set('notifications', notifications_json_string, { path: '/' })
                        }
                    }
                }
            }
          }
        }).catch((error) => {
            console.log(error)
        })
      }
    }

    componentDidMount() {
      const { cookies } = this.props;
      // if(cookies.get('token') != null){
      //   cookies.remove('token', { path: '/' })
      //   let port = (window.location.port ? ':' + window.location.port : '');
      //   window.location.href = '//' + window.location.hostname + port + '/signin';
      // }

      axios.get(Backend_Url + 'getUserDetailsByAccessToken/' + cookies.get('token'))
      .then(res => {
        this.setState({
          user_details: res.data
        });
      })
      .catch((error) => {
        console.log(error);
      });

      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))

      axios.post(Backend_Url + 'notifications', data)
      .then((res) => {
          let result = res.data
          var is_array = Array.isArray(result)
          if(is_array){
            if(result.length != 0){
                this.setState({notifications: result})
                
                // notification array cookie
                var array_string = cookies.get('notifications');
  
                if(array_string == null){
                    var notification_array = []
  
                    for (var i = 0; i < result.length; i++){
                        var notification_id = result[i]._id.$oid
  
                        // play sound alert
                        const alert_sound = new Audio(Notification);
                        alert_sound.play()
  
                        // add notification to notification array cookie
                        notification_array.push(notification_id)
                    }
                    var notifications_json_string = JSON.stringify(notification_array);
                    cookies.set('notifications', notifications_json_string, { path: '/' })
  
                }else{
                    var notification_array = JSON.parse(array_string);
  
                    for (i = 0; i < result.length; i++){
                        var notification_id = result[i]._id.$oid
  
                        // check if notification sound alert has already been put out
                        var alert_sent = notification_array.includes(notification_id)
  
                        if(alert_sent == false){
                            // play sound alert
                            const alert_sound = new Audio(Notification);
                            alert_sound.play()
  
                            // add notification to notification array cookie
                            notification_array.push(notification_id)
                            var notifications_json_string = JSON.stringify(notification_array);
                            cookies.set('notifications', notifications_json_string, { path: '/' })
                        }
                    }
                }
            }
          }
      }).catch((error) => {
          console.log(error)
      })
      this.interval = setInterval(() => this.UpdateNotifications(), 1000)      

    }




    render() {
      if (window.location.href.indexOf("/live-session/") > -1) {
        return<>
        </>
      }
      return (
        <>
          <this.SelectNavbarRender/>
        </>
      );
    }

  };
  
  export default withCookies(NavBar);